<template>
  <div :class="$props.class || ''">
    <div
      v-if="$props.new"
      class="uppercase font-bold text-xs text-primary-white bg-black px-1"
    >
      {{ $t('products.tagNew') }}
    </div>
    <div
      v-if="$props.personalizable"
      class="uppercase font-bold text-xs text-primary-white bg-primary-tangerine px-1"
    >
      {{ $t('products.tagPersonalizable') }}
    </div>
    <div
      v-if="$props.festive"
      class="uppercase font-bold text-xs text-primary-white bg-primary-tangerine px-1"
    >
      {{ $t('products.tagFestive') }}
    </div>
    <div v-if="tags" class="block">
      <div v-for="(tag, index) in tags" :key="index">
        <div
          v-if="tag"
          class="block float-left uppercase font-bold text-xs text-primary-white bg-primary-tangerine px-1"
        >
          {{ tag?.trim() }}
        </div>
      </div>
    </div>
    <div
      v-if="$props.magsafeCompatible"
      class="uppercase font-bold text-xs text-black bg-primary-white px-1"
    >
      {{ $t('products.tagMagsafe') }}
    </div>
  </div>
</template>

<script lang="ts" setup>
const { locale } = useI18n()
const props = defineProps<{
  new?: boolean
  personalizable?: boolean
  festive?: boolean
  magsafeCompatible?: boolean
  class?: string
  isLoading?: boolean
  customTags?: { th?: string; en: string }
}>()

const tags = computed(() => {
  if (locale.value === 'en') {
    return props.customTags?.en?.split(',')
  } else {
    return (props.customTags?.th || props.customTags?.en)?.split(',')
  }
})
</script>
